
export enum PromoWidgetStatus {
  pending = 'pending'
}
